// ** Custom Components
import Box from "../Box"
import SectionImage from "../SectionImage"
import { serializers } from "../Serializers"

// ** 3rd Party Library
import { PortableText } from "@portabletext/react"

const SectionColumnVideo = ({ section }: any) => {
  const { listItems, _rawContent: content } = section

  if (listItems[0]?.value) {
    return (
      <SectionImage
        image={
          <iframe
            className="h-[300px] lg:h-full w-full rounded-[18px]"
            src={listItems[0]?.value}
            title={listItems[0]?.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          ></iframe>
        }
        className="bg-gray-75 p-5 rounded-[20px] shadow-lg"
      >
        <Box className="py-8 [&>p]:mt-4 [&>h4]:font-extrabold [&>p]:lg:mt-8">
          <PortableText components={serializers} value={content} />
        </Box>
      </SectionImage>
    )
  }
  return null
}

export default SectionColumnVideo
